 
// var flkty = new Flickity( '.custom-photo', {
//   cellAlign: 'left',
//   contain: true,
//   autoPlay: true,
// pageDots: false
                
// });


var carousel = document.querySelector('.custom-photo');
if (carousel) {
  var flkty = new Flickity(carousel, {
    cellAlign: 'left',
    contain: true,
    autoPlay: true,
    pageDots: false
  });
}




//   var flkty = new Flickity('.product-slider-container', { 
// freeScroll: true,
// contain: true,
//     groupCells: 2,
// pageDots: false
// });